<template>
    <div>
        <navbar></navbar>
        <div class="__termbg">
            <div class="container">
                <p class="__bepro">Terms of service</p>
            </div>
        </div><br>
        <div class="container">
            <div class="row">
                <div class="col-md-2 col-sm-2"></div>
                <div class="col-md-8 col-sm-8">
                    <p class="__term"><b>Findworka</b> is an online marketplace for digital services and gigs, where customers find and connect with diverse qualified freelance experts in Africa in the most affordable, timely and secured manner.<br> The following terms and conditions ( "Terms of Service"), govern your access to and use of the Findworka website, including any content, functionality and services offered on or through www.findworka.com (the "Site"), by Findworka Solutions Ltd.</p>

                    <div class="accordion __term">
                        <h4 class="accordion-toggle">1.0 Agreement</h4>
                        <div class="accordion-content">
                            <p>
                                Please read the Terms of Service carefully before you start to use the Site. By using the Site, opening an account or by clicking to accept or agree to the Terms of Service when this option is made available to you, you accept and agree to be bound and abide by these Terms of Service and our Privacy Policy found here, incorporated herein by reference. If you do not want to agree to these Terms of Service or the Privacy Policy, you must not access or use the Site.
                            </p>
                            <hr>
                        </div>
                        
                        <h4 class="accordion-toggle">1.1 Definition of terms</h4>
                        <div class="accordion-content">
                            <p>
                                Member: a registered user of this site<br>
                                Visitor: unregistered user<br>
                                User (you): both member and visitor making use of the <b>findworka</b> Services on the site.<br>
                                Client: User in need of a service provider(s) and who hires them, which could be an individual or organization.<br>
                                Clients / Customers: are users who purchase services on <b>Findworka</b>.<br>
                                Service provider: means any individual or business who registers on the Website who has the digital skills to perform at least one of the service categories.<br>
                                Findworka also refer to as "us", "we", "our" and "ours".<br>
                                Project: means task/job/work or any activities that need to be done by a service provider(s).<br>
                                Deals / Gigs are services offered on <b>Findworka</b>.<br>
                                Deal Page is where the Service provider can describe their deal and the deal’s terms, and the Client can purchase the deal and create an order.<br>
                                Custom Offers are exclusive proposals that a Service provider can create in response to specific requirements of a Client.<br>
                                Requests are requests made by a Client to receive a Custom Offer from a Service provider. Orders are the formal agreement between a Client and Service provider after a purchase was made from the Service provider’s deal / service page.<br>
                                Conversation Page / Inbox is where Clients and Service providers communicate with each other about an ordered service.<br>
                                Disputes are disagreements experienced during an order between a Client and Service provider.<br>
                                Wallet is the money Service providers earn from completed orders. Site means the website of <b>findworka</b>.com and all the pages, content and sub-domains contained therein.
                            </p>
                            <hr>
                        </div>
                        
                        <h4 class="accordion-toggle">1.2 Overview (Main terms, in a nutshell)</h4>
                        <div class="accordion-content">
                            <p>
                                Only registered users may buy and sell on <b>Findworka</b>. Registration is free.<br>
                                Clients pay <b>Findworka</b> in advance to create an order.<br>
                                Orders are purchased through the Order button found on a Service provider’s Gig page or through a Custom Offer.<br>
                                Service providers / Service Providers gain account statuses (Levels) based on their performance and reputation. Advanced levels provide their owners with benefits, including offering services for higher prices through Service requests, or selling their Deals.<br>
                                Service providers must fulfill their orders, and may not cancel orders on a regular basis or without cause. Cancelling orders will affect Service providers’ reputation and status.<br>
                                Users may not offer or accept payments using any method other than placing an order through <b>Findworka</b>.com.<br>
                                Clients are granted all rights for the delivered work, unless otherwise specified by the Service provider during negotiation or on their Deal page. Note: some Deals charge additional payments (through Extras) for Commercial Use License. See our “Ownership” and “Commercial Use License” sections below for more information.<br>
                                <b>Findworka</b> retains the right to use all published delivered works for <b>Findworka</b> marketing and promotion purposes.<br>
                                We care about your privacy. You can read our Privacy Policy here. The Privacy Policy is a part of these Terms of Service.
                            </p>
                            <hr>
                        </div>

                        <h4 class="accordion-toggle">1.3 Services, Deals and Gigs</h4>
                        <div class="accordion-content">
                            <p>
                                Service providers are allowed to post a select active Deals Services, Deals and Profiles created on <b>Findworka</b> are User Generated Content.<br>
                                <b>Deals may be removed by <b>Findworka</b> for violations to these Terms of Service, which may include (but are not limited to) the following violations and/or materials:</b><br>
                                Illegal or Fraudulent services, Copyright Infringement, Trademark Infringement.<br> 
                                Copyright Infringement, Trademark Infringement reported through our Intellectual Property Claims Policy.<br>
                                Adult oriented services, Pornographic, Inappropriate/Obscene.<br> 
                                Intentional copies of Deals.<br>
                                Spam, Nonsense, or Violent Deals.<br>
                                Deals misleading to Clients, including violations of third party terms of service.<br>
                                Reselling of regulated goods.<br>
                                Deals that are removed for violations mentioned above, may result in the removal of the Service provider’s account.<br>
                                Deals that are removed for violations are not eligible to be restored or edited.<br>
                                Deals may be removed from our Search feature due to poor performance and/or user misconduct.<br>
                                URLs in your Deal text that redirect to third party websites are subject to approval and may be considered inappropriate to use on Findworka.<br>
                                Deals are required to have an appropriate deal image related to the service offered. An option to upload two additional deal images are available to all Service providers.<br>
                                Deals may contain an approved Deal Video uploaded through the Gig management tools available on Findworka.
                            </p>
                            <hr>
                        </div>

                        <h4 class="accordion-toggle">1.4 Eligibility</h4>
                        <div class="accordion-content">
                            <p>
                                This Site is offered and available to users who are 18 years of age or older. If you are under 18 you may not use this Site or the <b>Findworka</b> services. By using this Site, you represent and warrant that you are of legal age to form a binding contract with the Company and meet all of the foregoing eligibility requirements. If you do not meet all of these requirements, you must not access or use the Site.<br>
                                Our Customer Support team is available 24/7 if you have any questions regarding the Site or Terms of Service. Contacting our Customer Support team can be performed by calling <a href="tel:+2348171611434"><b class="__tcol">+234-817-161-1434</b></a> or send us mail at <a href="mailto:info@findworka.com"><b class="__tcol">info@findworka.com</b></a>.
                            </p>
                            <hr>
                        </div><br>
                        <h3>2. SERVICE PROVIDER</h3>
                        <h4 class="accordion-toggle">2.0 Basics</h4>
                        <div class="accordion-content">
                            <p>
                                Each order you sell and successfully complete, accredits your account with the agreed sum with the service provider. Findworka reserves the right to take a commission which will be discussed during the project negotiation<br>
                                <b>Findworka</b> accredits Service providers once an order is completed. See our "Orders" section below for a definition of a completed order.<br>Revenues are only made available for withdrawal from the Revenue page following a safety clearance period of 14 days after the order is marked as complete. Top Rated Service providers are eligible to withdraw revenue following a safety clearance period of 7 days after the order is marked as complete.<br>
                                Withdrawals from your account may become disabled upon review of our Trust & Safety team. This may be done for security concerns in order to prevent fraudulent transactions, reported poor performance or violations to our Terms of Service from Clients to our Customer Support team, or if another <b>Findworka</b> profile is associated to the same withdrawal providers. Enabling withdrawals will be evaluated by our Trust & Safety team following a review of your account.<br>
                                If an order is cancelled (for any reason), the funds paid will be refunded to the Client’s wallet.<br>
                                Service providers may withdraw their revenues using one of <b>Findworka</b>’s withdrawal options.<br>
                                The Service provider's rating is calculated based on the order reviews posted by Clients. High ratings allow Service providers to obtain advanced Service provider levels (see Levels below).
                            </p>
                            <hr>
                        </div>

                        <h4 class="accordion-toggle">2.1 Levels</h4>
                        <div class="accordion-content">
                            <p>
                                <b>Findworka</b> is all about helping Service providers leverage their skills. We seek to empower top performing Service providers with helpful tools to grow their business. Service providers who invest in self-promotion may achieve greater customer satisfaction. And, if they deliver on time and maintain high quality and ratings, Findworka may reward them with new statuses, special opportunities, benefits, and tools that come with it.<br>
                                <b>Findworka</b> Service providers can gain account Levels based on their activity, performance and reputation. The advancement criteria canbe found here.<br>
                                Advancement in Levels are updated periodically by an automated system.<br>
                                The current Levels a Service provider can achieve are, Level 1, 2, and Top Rated.<br>
                                Service providers who cannot maintain their high quality service, experience a severe drop in ratings, or stop delivering on time risk losing their Service provider status and the benefits that come with it. For example, late deliveries, warnings to the Service provider’s account and cancellations can cause a Service provider to move to a different Level.<br>
                                Advanced levels provide their owners with additional benefits.
                            </p>
                            <hr>
                        </div>

                        <h4 class="accordion-toggle">2.2 Top Rated Service providers</h4>
                        <div class="accordion-content">
                            <p>
                                Top Rated Service providers are chosen manually by <b>Findworka</b> editors based on seniority, volume of sales, extremely high rating, exceptional customer care and community leadership. Top Rated Service providers gain access to more extensive features than previous levels, including exclusive access to beta features and VIP support.<br>
                                Top Rated eligibility is constantly evaluated by <b>Findworka</b> to ensure that the quality standards of the Top Rated selection is kept. Top Rated Service providers who cannot maintain their high quality service through a severe drop in ratings, stop delivering on time, or violate our Terms of Service risk losing their Top Rated status and the benefits that come with it.
                            </p>
                            <hr>
                        </div>

                        <h4 class="accordion-toggle">2.3 Custom Offer</h4>
                        <div class="accordion-content">
                            <p>
                                Service providers can also send Custom Offers addressing specific requirements of a Client. Custom Offers are defined by the Service provider with the exact description of the service, the price and the time expected to deliver the service.<br>
                                Custom Offers are sent from the conversation page.
                            </p>
                            <hr>
                        </div>

                        <h4 class="accordion-toggle">2.4 Withdrawing Revenues</h4>
                        <div class="accordion-content">
                            <p>
                                To withdraw your revenue, you must have an account with at least one of Nigerian banks. (We will scale this very soon).<br>
                                Your <b>Findworka</b> profile can be associated with only one account from each Nigerian banks. A withdrawal provider account can be associated with only one Findworka profile.<br>
                                Revenues are only made available for withdrawal from the Revenue page following a safety clearance period of 14 days after the order is marked as complete.<br>
                                To withdraw your available revenue, you must click on the designated withdrawal provider to initiate the withdrawal process.<br>
                                Withdrawals can only be made in the amount available to you.<br>Withdrawal fees vary depending on the withdrawal provider method.<br>Withdrawals are final and cannot be undone. We will not be able to refund or change this process once it has begun.
                            </p>
                            <hr>
                        </div>
                    </div>

                </div>
                <div class="col-md-2 col-sm-2"></div>
            </div>
        </div><br><br>
    </div>
</template>

<script>
import navbar from '../components/navbar';



export default {
    components: { navbar,
    },
    mounted() {
        $(document).ready(function() {
            $('.accordion').find('.accordion-toggle').click(function() {
                $(this).next().slideToggle('600');
                $(".accordion-content").not($(this).next()).slideUp('600');
            });
            $('.accordion-toggle').on('click', function() {
                $(this).toggleClass('active').siblings().removeClass('active');
            });
        });
    }
}
</script>

<style scoped>
    .__bepro{
        font-size: 50px;
        font-weight: 600;
        line-height: 1.2;
        color: #ffffff;
    }

    .__term {
        font-size: 14px;
        line-height: 1.65;
        color: #000000;
        margin-top: 18px;
    }

    .accordion{
        width:100%; 
        margin: 0 auto;
    }
    .accordion-toggle {
        border-bottom: 1px solid #cccccc;
        cursor: pointer;
        margin: 0;
        padding: 20px 0;
        position: relative;
    }
    .accordion-toggle.active:after{
        content:"";
        position:absolute;
        right:0;top:17px;
        width:0;height:0;
        border-bottom:5px solid #0000ef;
        border-left:5px solid #fff;
        border-right:5px solid #fff;
    }
    .accordion-toggle:before{
        content:"";
        position:absolute;
        right:0;
        top:25px;
        width:0;
        height:0;
        border-top:5px solid #000;
        border-left:5px solid #fff;
        border-right:5px solid #fff;
    }
    .accordion-toggle.active:before{
        display:none;
    }
    .accordion-content {
        display: none;
        font-size: 16px;
        padding: 20px 0;
        text-align: justify;
    }
    .accordion-toggle.active {
        color: #0000ef;
    }
</style>


// WEBPACK FOOTER //
// src/components/term.vue